import React from "react";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToSection as scrollTo } from "./lenis";


export const Services = () => (
  <section id="services" className="relative py-24 md:py-32 bg-[#0d0d0d]">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <Reveal><Eyebrow color="#F56FB4">What We Do</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading font-extrabold uppercase text-white text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight mt-3">
              Our <span className="text-[#53C653]">Services</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="text-white/60 max-w-sm text-base leading-relaxed">
            We handle the mess, so you can enjoy the space. From a single item to an
            entire property — no job is too big or too small.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
        {SERVICES.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Truck;
          const accent = i % 2 === 0 ? "#F56FB4" : "#53C653";
          return (
            <Reveal key={s.title} delay={(i % 4) * 0.06}>
              <div
                data-testid={`service-card-${i}`}
                className="group relative h-full rounded-3xl border border-white/10 bg-[#161616]/70 backdrop-blur-xl p-7 transition-transform duration-300 hover:-translate-y-2 overflow-hidden"
                style={{ "--a": accent }}
              >
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                  style={{ boxShadow: `inset 0 0 0 1px ${accent}66, 0 0 30px ${accent}22` }}
                />
                <div
                  className="inline-flex items-center justify-center rounded-2xl w-14 h-14 mb-5 transition-transform duration-300 group-hover:scale-110"
                  style={{ background: `${accent}1a`, border: `1px solid ${accent}40` }}
                >
                  <Icon size={26} style={{ color: accent }} />
                </div>
                <h3 className="font-heading font-bold text-xl text-white uppercase tracking-tight">{s.title}</h3>
                <p className="text-sm text-white/55 mt-2 leading-relaxed">{s.desc}</p>
                <button
                  onClick={() => scrollTo("quote")}
                  className="mt-5 inline-flex items-center gap-1 text-sm font-semibold transition-colors duration-200"
                  style={{ color: accent }}
                >
                  Learn More
                  <ArrowUpRight size={16} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Services;
